//=============================================================================
// Contents   : HRDB
//              更新テンプレート
//              UpDateTemp
// Author     : RV光永 
// LastUpdate : 2022/12/1
// Since      : 2022/11/31
//=============================================================================

/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */

/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */

/* ====== React ====== */
import React,{ useEffect, useState } from "react";
import { useForm,useFieldArray } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
// import { useProvideData } from "03CommonApiParts/use-context";

/* ====== CSS ====== */

/* ====== Image ====== */

/* ====== Component Js/Jsx ====== */
import { LoadingProgressBar } from "02CommonUiParts/OtherParts/LoadingProgressBar";
import { SnackBar } from "02CommonUiParts/MessageParts/SnackBar";
import { LeftTitleTable } from "02CommonUiParts/TableParts/LeftTitleTable";
import { Underbar } from "02CommonUiParts/OtherParts/Underbar";
import { Title } from "01Pages/Common/UiParts/Title";

/* ====== Style ====== */
import { StyleCommon } from "01Pages/Common/Style/StyleCommon";

/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */  

/* ====== Styled Components ====== */
/* ------ページコンテンツ ------*/

/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */
/* ベース64スイッチ */

/* ======================================================================== */  
/* ================================ dummy ================================= */  
/* ======================================================================== */

/* ---従業員情報ダミーデータ--- */ 
const dummyEmployeeInfoData = {
    metadata:{
        count:1
    },
    payload:{
        applyDate:'2022-10-10',
        employeeNumber:'11111',
        employeeFirstNameKanji:'豊田',
        employeeLastNameKanji:'太郎',
        employeeFirstNameKana:'ﾄﾖﾀ',
        employeeLastNameKana:'ﾀﾛｳ',
        employeeFirstNameRoma:'toyota',
        employeeLastNameRoma:'taro',
        employeeNameFamilyRegister:'豊田太郎',
        employeeNameAbbreviations:'豊田太郎',
        gender:'men',
        birthday:'1990-11-11',
        comment:'コメントが書かれます',
        employmentStatus:'fullTime',
        hireDate:'2020-04-01',
        contractFilingDate:'2020-03-29',
        workLocation:'nagoya',
        workLocationAddress:'nagoyaAddress',
        rank:'general',
        grade:'guide1',
        departmentCode:'01E03201',
        departmentName:'コーポレートIT本部_ダミー',
        departmentPosition:'manager',
        pluralOfficesDepartmentCode:'01E03202',
        pluralOfficesDepartmentName:'経営管理部',
        pluralOfficesDepartmentPosition:'floreLeader',
        personnelCostCategory:'costPrice',
        personnelRequestApprovalNumber:'111111',
        leaveOfAbsenceCategory:'',
        lastWorkDay:'2022-11-25',
        retirementDate:'',
        moveInDateRemarksColumn:'転入備考欄が書かれます',
        moveOutDateRemarksColumn:'転出備考欄が書かれます'
    }};
    

    /* ---従業員情報ダミーデータ--- */ 
    /*性別データ */
    const sexData = {list:[{value:'men',label:'男性'},{value:'women',label:'女性'}
    ]};
    /*雇用形態データ */
    const employeeStatus = {list:[{value:'fullTime',label:'総合職正社員'},{value:'contract',label:'契約社員'},{value:'temporary',label:'派遣社員'}
    ]};
    /*勤務地データ */
    const locationData = {list:[{value:'tokyo',label:'東京'},{value:'nagoya',label:'名古屋10F'},{value:'osaka',label:'大阪'}
    ]};
    /*勤務地住所データ */
    const addressData = {list:[{value:'nagoyaAddress',label:'愛知県名古屋市中区錦一丁目11番11号名古屋インターシティ14階'},{value:'shibuya',label:'渋谷区'},{value:'adachi',label:'足立区'}
    ]};
    /*ランクデータ */
    const rankData = {list:[{value:'special',label:'特別'},{value:'general',label:'一般I'}
    ]};
    /*等級データ */
    const gradeData = {list:[{value:'guide1',label:'指導職1級'},{value:'guide2',label:'指導職2級'},{value:'guide3',label:'指導職3級'}
    ]};
    /*役職データ */
    const acterData = {list:[{value:'manager',label:'部長'},{value:'floreLeader',label:'室長'},{value:'sectionChief',label:'課長'},{value:'chief',label:'係長'},{value:'member',label:'社員'}
    ]};
    /*人件費区分データ */
    const laborCostData = {list:[{value:'expence',label:'経費'},{value:'generalExpence',label:'一般管理費'},{value:'costPrice',label:'原価'}
    ]};
    /*休職区分データ */
    const absenceData = {list:[{value:'illness',label:'病気休職'},{value:'accident',label:'事故休職'},{value:'prosecution',label:'起訴休職'},{value:'adjustment',label:'調整休職'},{value:'request',label:'依頼休職'}
    ]};
    /* 業務部署ダミーデータ */ 
    const businessDammy = {
        list:[
            {value1:'pluralOfficesDepartmentCode',type1:'input',value2:'pluralOfficesDepartmentName',type2:'input',value3:'pluralOfficesDepartmentPosition',type3:'select',range:acterData},
        ]
    };

/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */

/* ========= 編集画面テンプレート ========= */
export const UpdateTemp = () => {

    /* ---------------------------------------------------- */
    /* ------------------ Instance ------------------------ */
    /* ---------------------------------------------------- */

    const navigate = useNavigate();//画面遷移用
    // const apiData = useProvideData();//APIデータ取得
    const CommonStyle = StyleCommon();//共通スタイルドコンポーネント

    /* ----------------------------------------------------- */
    /* ----------------- reack-hook-form ------------------- */
    /* ----------------------------------------------------- */

    /* ====== hookformを定義 ====== */ 
    const { register, getValues,setValue, handleSubmit,control ,formState: { errors } } = useForm({
            mode: 'onBlur',
            reValidateMode: 'onChange',
            shouldUseNativeValidation: false,
            shouldUnregister: false,
            escalationCode:'false',
            defaultValues:{
                payload:{
                    plurale:[
                        {pluralOfficesDepartmentCode:'01E03202',pluralOfficesDepartmentName:'経営管理部',pluralOfficesDepartmentPosition:'floreLeader'},
                        {pluralOfficesDepartmentCode:'01E03202',pluralOfficesDepartmentName:'経営管理部',pluralOfficesDepartmentPosition:'floreLeader'}
                    ]
                }
            }
        });

    /* ====== useFieldArrayを定義 ====== */ 
    const { fields:Fields, append:Append, remove:Remove } = useFieldArray(
        {
            control,
            name: "payload.plurale"
        }
    );

    /* ====== useWatchを定義 ====== */ 

    /* ---------------------------------------------------- */
    /* ------------------ variables ----------------------- */
    /* ---------------------------------------------------- */

    /* ====== sessionStorageからの情報を定義 ====== */ 

    /* ====== localStorageからの情報を定義 ====== */ 

    /* ====== storageから取得した情報をJavaScriptオブジェクトに変換 ====== */ 


    /* ---------------------------------------------------- */
    /* ---------------------- state ----------------------- */
    /* ---------------------------------------------------- */

    const [loading, setLoading] = useState(false); //画面表示用
    // const [progress, setProgress] = useState(false); //プログレスバー表示用
    const progress = false;
    const [snackbarMessage, setSnackbarMessage] = useState({ //スナックバー表示用
        open:false,
    });
    const [dataRow, setDataRow] = useState([]);//データ格納用
    // const [displayData, setDisplayData] = useState([]);//画面表示用
    const [businessData, setBusinessData] = useState([]);//業務部署用配列
    
    /* ---------------------------------------------------- */
    /* ---------------------- function -------------------- */
    /* ---------------------------------------------------- */

    /* ====== 初期表示 ====== */ 
    useEffect(() => {
        
        /* APIデータ取得 */
        getData();
        setLoading(true);

    // /* 画面表示開始 */
    // setLoading(false);
    // eslint-disable-next-line
    },[]);

    /* ====== APIからデータ取得 ====== */ 
    const getData = async() =>{

    //     /* プログレスバー表示 */
    //     setProgress(true);

        /* リクエスト先 */
        // const apiPath = '/helpdesk/employee/getlist';	//API Path

        /* 検索キー */
        // const searchKey = {};


        //検索フィールドから検索値を取得


        /* 操作ログ定義 */

        /* リクエストパラメータ */
        // const apiBody = { key: searchKey };

        // /* API処理開始 */
        // await apiData.getDataPost(apiPath, apiBody, (result) => {

            /* プログレスバー非表示 */
            // setProgress(false);

            // // if (result.isSuccessed) {//APIリクエスト結果 = 正常
            // /* データ編集用配列 */
            const data = dummyEmployeeInfoData.payload;

                /* APIから取得したデータを、データ編集用配列に格納 */
                const dataEdit = [];
                //従業員情報
                dataEdit.applyDate = data.applyDate;//〇〇データ
                dataEdit.employeeNumber = data.employeeNumber;//〇〇データ
                dataEdit.employeeFirstNameKanji = data.employeeFirstNameKanji;//〇〇データ
                dataEdit.employeeLastNameKanji = data.employeeLastNameKanji;//〇〇データ
                dataEdit.employeeFirstNameKana = data.employeeFirstNameKana;//〇〇データ
                dataEdit.employeeLastNameKana =data.employeeLastNameKana;//〇〇データ
                dataEdit.employeeLastNameKana =data.employeeLastNameKana;//〇〇データ
                dataEdit.employeeFirstNameRoma = data.employeeFirstNameRoma;//〇〇データ
                dataEdit.employeeLastNameRoma = data.employeeLastNameRoma;//〇〇データ
                dataEdit.employeeNameFamilyRegister = data.employeeNameFamilyRegister;//〇〇データ
                dataEdit.employeeNameFamilyRegister = data.employeeNameFamilyRegister;//〇〇データ
                dataEdit.employeeNameAbbreviations = data.employeeNameAbbreviations;//〇〇データ
                dataEdit.gender = data.gender;//〇〇データ
                dataEdit.birthday = data.birthday;//〇〇データ
                dataEdit.comment = data.comment;//〇〇データ
                dataEdit.employmentStatus = data.employmentStatus;//〇〇データ
                dataEdit.hireDate = data.hireDate;//〇〇データ
                dataEdit.contractFilingDate = data.contractFilingDate;//〇〇データ
                dataEdit.workLocation = data.workLocation;//〇〇データ
                dataEdit.workLocationAddress = data.workLocationAddress;//〇〇データ
                dataEdit.rank = data.rank;//〇〇データ
                dataEdit.grade = data.grade;//〇〇データ
                dataEdit.departmentCode = data.departmentCode;//〇〇データ
                dataEdit.departmentName = data.departmentName;//〇〇データ
                dataEdit.position = data.position;//〇〇データ
                // 兼務部署
                // const pluralOfficesDepartment = data.pluralOfficesDepartment;//兼務部署の配列を定義
                // dataEdit.pluralOfficesDepartment = [];//兼務部署の入れ物用意
                // pluralOfficesDepartment.forEach((item,index)=>{//兼務部署配列ぐるぐる
                //     console.log(item)
                //     dataEdit.pluralOfficesDepartment.push({
                //         pluralOfficesDepartmentCode:item.pluralOfficesDepartmentCode,
                //         pluralOfficesDepartmentName:item.pluralOfficesDepartmentName,
                //         pluralOfficesDepartmentPosition:item.pluralOfficesDepartmentPosition
                //     })
                // })     
                dataEdit.pluralOfficesDepartmentCode = data.pluralOfficesDepartmentCode;//〇〇データ
                dataEdit.pluralOfficesDepartmentName = data.pluralOfficesDepartmentName;//〇〇データ
                dataEdit.pluralOfficesDepartmentPosition = data.pluralOfficesDepartmentPosition;//〇〇データ
                dataEdit.personnelCostCategory = data.personnelCostCategory;//〇〇データ
                dataEdit.personnelRequestApprovalNumber = data.personnelRequestApprovalNumber;//〇〇データ
                dataEdit.leaveOfAbsenceCategory = data.leaveOfAbsenceCategory;//〇〇データ
                dataEdit.lastWorkDay = data.lastWorkDay;//〇〇データ
                dataEdit.retirementDate = data.retirementDate;//〇〇データ
                dataEdit.moveInDateRemarksColumn = data.moveInDateRemarksColumn;//〇〇データ
                dataEdit.moveOutDateRemarksColumn = data.moveOutDateRemarksColumn;//〇〇データ
                
                /* APIデータ格納用のstate更新 */
                setDataRow(dataEdit);
                // setValue('payload',dataEdit)

                /* 業務部署データ格納 */
                setBusinessData(businessDammy)
            //  /* 画面表示用用のstate更新 */
            //  setDisplayData(dataEdit);
             
            //  /* スナックバー表示 */
            //  setSnackbarMessage({      
            //      ...snackbarMessage,
            //      open:true,
            //      message:result.responseData.payload.length === 0 ?'CMNI004':'CMNI001',//データの取得成功
            //      $1:result.responseData.payload.length,//件数表示
            //      type: 2,
            //  }); 

            // }else{//APIリクエスト結果 = 異常
                /* プログレスバー非表示 */
                // setProgress(false);

        //     /* スナックバー表示 */
        //     setSnackbarMessage({      
        //         ...snackbarMessage,
        //         open:true,
        //         message:result,//APIによるエラー
        //         $1:result.responseData ? result.responseData.data.metadata: '',//取得件数
        //         type: 1,//APIエラー時:1,それ以外:2 
        //         level:'error',//エラースナックバー
        //     })
        // }
    }


    /* ====== 戻るボタン押した時の処理 ====== */
    const onClickBack = () => {
        navigate('/gettemp')
    };

    /* ====== 確認ボタンを押した時の処理 ====== */
    const onClickSubmit = () => {
        // navigate('/confirmtemp')
    };

    /* ====== 兼務部署プラスボタンを押した時の処理 ====== */
    // const onClickplus = () => {
    //      /* 1レコード取得 */
    //      const copyRecode = {...businessData.list[0]}
    //      copyRecode['value1'] = "pluralOfficesDepartmentCode1"
    //      copyRecode['value2'] = "pluralOfficesDepartmentName1"
    //      copyRecode['value3'] = "pluralOfficesDepartmentPosition1"
    //     /* オブジェクトをコピー */
    //     var businessCopy = {...businessData}
    //     businessCopy.list.push(copyRecode)
    //     /* ステートにセット */
    //     setBusinessData(businessCopy)
    // };

   /* ====== 兼務部署マイナスボタンを押した時の処理 ====== */
    const onClickCross=(e,index) => {
        /* オブジェクトをコピー */
        var deleteList = {...businessData}
        deleteList.list.splice(index,1)
        /* ステートにセット */
        setBusinessData(deleteList)
    };

    /* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */

    /* ====== LeftTitleテーブルの設定 ====== */
    //id:idを指定
    //label:左側に表示するタイトル*
    //list:右側に表示するコンテンツのリスト *
    //name:項目名
    //name2:項目名(type:categoryLabelを選択時のみ指定　minorCategory)
    //title:inputなどの隣に表示するタイトル
    //type:表示タイプ label/input/select/date/datetime/categoryLabel(問合せ情報問合せ種別用) *
    //rightLabel:inputなどの隣に表示するラベル 例：メールドメインなど
    //disable:変更不可にする true/false
    //readOnly:ラベル風にする　true/false（select/date/datetime)
    //width:幅の変更をする(inputのみ)

    /* ====== LeftTitleテーブルのデータ ====== */
    const inquieyTableConfig = 
    [
        /*適用日 */
        {
            id:'row1', 
            label:'適用日',
            required:true, 
            list:[
                {name:'applyDate',type:'date',required:true,},
            ]
        },
        /*従業員番号 */
        {id:'row2', 
        label:'従業員番号', 
        list:[
                {name:'employeeNumber',   type:'input',maxLength:20},
            ]
        },
        /*従業員名 */
        {
            id:'row3', 
            label:'氏名',
            list:[
                {name:'employeeFirstNameKanji', type:'input',title:'姓：',maxLength:20},
                {name:'employeeLastNameKanji', type:'input',title:'名：', maxLength:20},

            ]
        },
        /*従業員名 */
        {
            id:'row3', 
            label:'フリガナ',
            list:[
                {name:'employeeFirstNameKana', type:'input',title:'ｾｲ：',maxLength:20},
                {name:'employeeLastNameKana', type:'input',title:'ﾒｲ：',maxLength:20},

            ]
        },
        /*従業員名 */
        {
            id:'row3', 
            label:'英名',
            list:[
                {name:'employeeFirstNameRoma', type:'input',title:'Surname：',maxLength:20},
                {name:'employeeLastNameRoma', type:'input',title:'Given name：',maxLength:20},
            ]
        },
        /*従業員名 */
        {
            id:'row3', 
            label:'略名',
            list:[
                {name:'employeeNameFamilyRegister', type:'input',maxLength:20},
            ]
        },
        /*従業員名 */
        {
            id:'row3', 
            label:'戸籍名',
            list:[
                {name:'employeeNameAbbreviations', type:'input',maxLength:20},
            ]
        },
        /*性別 */
        {
            id:'row4', 
            label:'性別',
             required:true,
             list:[
                {name:'sex', type:'radioButton',required:true,range:sexData},
            ]
        },
        /*生年月日 */
        {
            id:'row5', 
            label:'生年月日', 
            list:[
                {name:'birthday', type:'date'},
            ]
        },
        /*コメント */
        {
            id:'row6', 
            label:'コメント', 
            list:[
                {name:'comment', type:'textarea',maxLength:20},
            ]
        },
        /*雇用形態 */
        {
            id:'row7', 
            label:'雇用形態',
            required:true, 
            list:[
                {name:'employmentStatus', type:'select',required:true,range:employeeStatus},
            ]
        },
        /*入社日(開始日) */
        {
            id:'row8', 
            label:'入社日(開始日)', 
            list:[
                {name:'hireDate', type:'date',required:true},
            ]
        },
        /*契約書提出日 */
        {
            id:'row9', 
            label:'契約書提出日', 
            list:[
                {name:'contractFilingDate', type:'date'},
            ]
        },
        /*勤務地 */
        {
            id:'row10', 
            label:'勤務地', 
            required:true,
            list:[
                {name:'workLocation', type:'select',required:true,range:locationData},
            ]
        },
        /*勤務地住所 */
        {
            id:'row11', 
            label:'勤務地住所', 
            list:[
                {name:'workLocationAddress', type:'select',range:addressData},
            ]
        },
        /*ランク */
        {
            id:'row12', 
            label:'ランク', 
            list:[
                {name:'rank', type:'select',range:rankData},
            ]
        },
        /*等級 */
        {
            id:'row13', 
            label:'等級', 
            list:[
                {name:'grade', type:'select',range:gradeData},
            ]
        },
        /*部署 */
        {
            id:'row14', 
            label:'部署', 
            required:true,
            list:[
                {name:'departmentCode', type:'input',required:true,maxLength:20,title:'部署コード：'},
                {name:'departmentName', type:'input',required:true,maxLength:20,title:'部署名：'},
                {name:'departmentPosition', type:'select',required:true,title:'役職：',range:acterData},
            ]
        },
        /*兼務部署 */
        // {
        //     id:'row15', 
        //     label:'兼務部署', 
        //     list:[
        //         {name:'pluralOfficesDepartmentCode', name1:'pluralOfficesDepartmentName',name2:'pluralOfficesDepartmentPosition',type:'businessTable',recodeData:businessData.list,onClickPlus:()=>onClickplus()},
        //     ]
        // },
        {
            id:'row15', 
            label:'兼務部署', 
            list:[
                {
                    name:'plurale', 
                    type:'table',
                    tableHeader:[{value:'departmentCode',label:'部署コード'},{value:'departmentName',label:'部署名'},{value:'departmentPosition',label:'役職'}],
                    tableData:[{id:'pluralOfficesDepartmentCode',label:'インプット',type:'input',maxLength:20},{id:'pluralOfficesDepartmentName',label:'インプット',type:'input'},{id:'pluralOfficesDepartmentPosition',label:'セレクト',type:'select',range:acterData}],
                    fields:Fields,
                    append:Append,
                    remove:Remove,
                },
            ]
        },
        /*人件費区分 */
        {
            id:'row16', 
            label:'人件費区分', 
            list:[
                {name:'personnelCostCategory', type:'select',range:laborCostData},
            ]
        },
        /*人事稟議書No */
        {
            id:'row17', 
            label:'人事稟議書No.', 
            list:[
                {name:'personnelRequestApprovalNumber', type:'input',maxLength:20},
            ]
        },
        /*休務/休職区分 */
        {
            id:'row18', 
            label:'休務/休職区分', 
            list:[
                {name:'leaveOfAbsenceCategory', type:'select',range:absenceData},
            ]
        },
        /*最終出社日 */
        {
            id:'row19', 
            label:'最終出社日', 
            list:[
                {name:'lastWorkDay', type:'date'},
            ]
        },
        /*退職日(終了日) */
        {
            id:'row20', 
            label:'退職日(終了日)', 
            list:[
                {name:'retirementDate', type:'date'},
            ]
        },
        /*転入日備考欄 */
        {
            id:'row21', 
            label:'転入日備考欄', 
            list:[
                {name:'moveInDateRemarksColumn', type:'textarea',maxLength:20},
            ]
        },
        /*転出日備考欄 */
        {
            id:'row22', 
            label:'転出日備考欄', 
            list:[
                {name:'moveOutDateRemarksColumn', type:'textarea',maxLength:20},
            ]
        },

    ];
        /*====== アンカーコンテンツ ======*/
        const anchorContents = [
            {id:'employee',name:'従業員情報',  status:'employee'},
        ];

    /* ---------------------------------------------------- */
    /* ----------------------- jsx ------------------------ */
    /* ---------------------------------------------------- */

    /* ====== 画面表示開始前 ====== */
    if(!loading){
        return(
        <></>
        );
    };


    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */

    return(
        <>
            {/* プログレスバーの表示 */}
            <LoadingProgressBar open={progress}/>
            {/* 画面タイトル */}
            <Title text='従業員情報編集' dataRow={dataRow} contents={anchorContents} />
            <form onSubmit={handleSubmit(onClickSubmit)}>
            {/* <Table /> */}
            <CommonStyle.GdivPageContentsWrapper>
                {/* ページコンテンツ */}
                    {/* 問合せ情報テーブル */}
                    <CommonStyle.GdivSubTitleWrapper id='inquiry'>
                        従業員情報
                    </CommonStyle.GdivSubTitleWrapper>
                    <LeftTitleTable
                        className='baseText'
                        register={register}
                        payload='payload'
                        error={errors}
                        dataRow={dataRow}
                        tableConfig={inquieyTableConfig}
                        getValues={getValues}
                        setValue={setValue}
                        onClickCross={(e,index)=>onClickCross(e,index)}
                    />
            </CommonStyle.GdivPageContentsWrapper>
                {/* アンダーバー */}
                <Underbar
                     payload="payload"  //react-hook-form
                     register={register} //react-hook-form
                     error={errors} //react-hook-form
                     type='confirm' //react-hook-form
                     onClickBack={onClickBack}//戻るボタン押下時の処理
                     onClickSubmit={onClickSubmit}//更新ボタン押下時の処理
                 />
            </form>
            {/* ダイアログ */}
            {/* <Dialog
				content={dialogMessage}
				set={setDialogMessage}
				onClickOK={onClickDialogOK}
				onClickSave={()=>TemporarySave(getValues('payload'),'back')}
			/>  */}
            {/* スナックバー */}
            <SnackBar
                content={snackbarMessage}
                set={setSnackbarMessage}
            />
                
        </>
    );
};

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */